export default __webpack_public_path__ + "static/media/Blackfang.710c505d.jpg";